// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LoHL","col":"styles_col__2OVvy"};